import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";

let themechange = "light";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      textAlign: "left",
      borderRadius: 0,
      borderBottom: "2px solid #008CD7",
      backgroundColor: themechange === "light" ? "#C1C1C1" : "#3C3C3C",
      color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
      fontSize: "18px",
      fontWeight: 400,
      fontFamily: "Roboto",
      // overflowY: 'scroll',
      // scrollbarWidth: '10px',
      // visibility: 'visible',
      // scrollbarWidth: '10px',
      // '::-webkitScrollbarThumb': {
      //     background: 'pink',
      //     borderRadius: '5px'
      // }
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.indexOf(name) === -1 ? 400 : 700,
    color:
      personName.indexOf(name) === -1
        ? themechange === "light"
          ? "#3C3C3C"
          : "#FFFFFF"
        : "#FFFFFF",
    backgroundColor: themechange === "light" ? "#C1C1C1" : "#3C3C3C",
  };
}

export default function CustomMultiSelect({
  mandatory,
  mandatoryText,
  names,
  width,
  selectedValues,
  disabled,
  personName,
  setPersonName

}) {
  themechange = useSelector((state) => state.themedata.theme);
  const theme = useTheme();
  //const [personName, setPersonName] = React.useState([]);

  const handleDelete = (e, value) => {
    setPersonName((current) => current.filter((item) => item !== value));
    selectedValues(personName.filter((item) => item !== value));
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === "string" ? value.split(",") : value);
    selectedValues(value);
  };

  return (
    <FormControl
        variant="standard"
        sx={{ width: width ? `${width}px` : "273px" }}
    >
      <Select
        disabled={disabled ? disabled : false}
        sx={{
            "&:before": {
                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: '2px solid #008CD7',
            },
            "&:after:not(.Mui-disabled):before": {
                borderBottom: '2px solid #008CD7',
            },
            "& .MuiSvgIcon-root": {
                color: "var(--PrimaryText)",
            },
            "& .MuiInputBase-input:focus": {
                color: "var(--HighlightedText_Stroke)",
            },
            "& .MuiInputBase-root-MuiInput-root-MuiSelect-root::before": {
                borderBottom: "1px solid var(--PrimaryText) !important",
            },
            "& .MuiInputBase-root::after": {
                borderBottom: "2px solid var(--HighlightedText_Stroke)",
            },
            "&*::before": {
                borderBottom: "1px solid var(--PrimaryText) !important",
            },
            "& .MuiList-root .MuiMenu-list": {
                padding: 0,
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: 0,
            },
        }}
        multiple
        value={personName}
        onChange={handleChange}
        renderValue={(selected) => (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              flexDirection: "row",
            }}
          >
            {selected.map((value) => (
              <Chip
                key={value}
                label={value}
                onDelete={(e) => handleDelete(e, value)}
                deleteIcon={
                  <ClearOutlinedIcon
                    onMouseDown={(event) => event.stopPropagation()}
                  />
                }
                sx={{
                  borderRadius: 0,
                  padding: 0,
                  backgroundColor: "var(--dropdown-bg)",
                  color: "var(--PrimaryText)",
                  fontFamily: "Roboto",
                  fontSize: "18px",
                  fontWeight: 700,
                  height: "21px",
                  width: "177px",
                  justifyContent: "flex-start",
                  "& .MuiChip-deleteIcon": {
                    color: "var(--PrimaryText)",
                    position: "absolute",
                    right: "0px",
                  },
                  "& .MuiChip-label": {
                    paddingLeft: "0px",
                    paddingRight: "25px",
                  },
                }}
              />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
        IconComponent={KeyboardArrowDownIcon}
      >
        {names.map((name) => (
          <MenuItem
            key={name}
            value={name}
            style={getStyles(name, personName, theme)}
          >
            {name}
          </MenuItem>
        ))}
      </Select>
      {(personName=='') && (mandatory==true) && <Typography sx={{fontSize:"12px",fontFamily:"Roboto",color:'#DC272D',fontWeight: 400}}>Please select at least 1 {mandatoryText}</Typography>}
    </FormControl>
  );
}
